import gql from 'graphql-tag';
export default gql`
  query getBusinessInfo($param: String!, $region: String) {
    getBusinessInfo(param: $param, region: $region) {
      rows {
        abn
        name
        status
        stateCode
        postCode
        entityType
        registerNumber
        contactDetail {
          name
          email
          contactNumber
          street
          suburb
          state
          postCode
        }
      }
      status
    }
  }
`;
